/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Specification for a rollout execution.
 */
export interface RolloutExecutionSpec { 
    /**
     * Ignore execution of scheduled actions & notifications (Only used for testing).
     */
    simulated?: boolean;
    /**
     * Allow customer to reschedule the rollout into another wave.
     */
    allow_reschedule_by_customer?: boolean;
    /**
     * Ignore validation of target against action spec.
     */
    skip_target_validation?: boolean;
}

